export default __webpack_public_path__ + "static/media/banner2.5f4ac68f.png";